var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "406.000000pt",
    height: "405.000000pt",
    viewBox: "0 0 406.000000 405.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,405.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1363 2964 c-3 -8 -4 -263 -1 -565 l5 -549 38 -78 c97 -197 320 -328 524 -307 254 25 434 203 466 459 l7 56 -151 0 -151 0 0 -24 c0 -33 -25 -100 -51 -135 -77 -105 -259 -107 -349 -5 l-30 35 0 137 c0 241 -12 967 -16 980 -2 9 -40 12 -144 12 -119 0 -142 -2 -147 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1890 2837 l0 -147 58 0 c82 0 199 -32 291 -80 229 -119 371 -360 371 -627 0 -121 -22 -212 -75 -319 -108 -220 -329 -373 -565 -391 l-80 -6 0 -149 0 -150 53 7 c269 33 467 127 645 306 213 214 326 530 294 816 -40 350 -237 637 -537 783 -127 62 -228 89 -355 97 l-100 6 0 -146z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBig);
export default __webpack_public_path__ + "static/media/logo_big.d8af67a0973ec870a2a146bac0a4be66.svg";
export { ForwardRef as ReactComponent };